import { render, staticRenderFns } from "./OriginalLandownerReport.vue?vue&type=template&id=95c6f40e"
import script from "./OriginalLandownerReport.vue?vue&type=script&lang=js"
export * from "./OriginalLandownerReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports